/*
 * Framework
 *
 * WindowWidth
 * ------
 * Check window widths
 *
 */
/* global Framework jQuery */

var throttle = require('throttle-debounce/throttle');
var PubSub = require('pubsub-js');

(function ($) {
  'use strict';

  function WindowWidth() {}

  WindowWidth.prototype = {
    /*
     * Set up window width detection
     */
    init: function () {
      // set up JS variable shortcuts
      this.w = window;
      this.d = document;
      this.e = this.d.documentElement;
      this.g = this.d.getElementsByTagName('body')[0];

      // get window width
      this.ww = this.w.innerWidth || this.e.clientWidth || this.g.clientWidth;

      // update window width on resize - throttled to save on processing
      this.throttled = throttle(50, false, this._onResize);
      $(window).on('resize orientationchange', $.proxy(this.throttled, this));
    },

    /*
     * update window width on resize
     */
    _onResize: function () {
      this.ww = this.w.innerWidth || this.e.clientWidth || this.g.clientWidth;

      // publish resize for any listeners
      PubSub.publish('windowResized');
    },

    /*
     * Test window width
     *
     * Example usage:
     * if (Framework.windowWidth.lt('large')) { ... }
     */
    lt: function (windowSize) {
      if (typeof windowSize === 'number') {
        return this.ww < windowSize;
      } else {
        return this.ww < Framework.CONSTANTS.MQ[windowSize];
      }
    },
    lte: function (windowSize) {
      if (typeof windowSize === 'number') {
        return this.ww <= windowSize;
      } else {
        return this.ww <= Framework.CONSTANTS.MQ[windowSize];
      }
    },
    gt: function (windowSize) {
      if (typeof windowSize === 'number') {
        return this.ww > windowSize;
      } else {
        return this.ww > Framework.CONSTANTS.MQ[windowSize];
      }
    },
    gte: function (windowSize) {
      if (typeof windowSize === 'number') {
        return this.ww >= windowSize;
      } else {
        return this.ww >= Framework.CONSTANTS.MQ[windowSize];
      }
    },
  };

  this.WindowWidth = WindowWidth;
}.call(Framework, jQuery));
